import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
})
export default class OptionalRouterLinkComponent extends Vue {}
